import { useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Select, type SelectProps } from '@wf/components';

import useLicenseAbbreviation from '../../../../../../hooks/useLicenseAbbreviation';
import useLicenseTypeNature from '../../../../../../hooks/useLicenseTypeNature';

import { getSelectOptionsFromObjectArray } from '../../../../../../helpers/getSelectOptionsFromObjectArray';
import { licenseTypesSelector } from '../../../../../../store/licenseType/selectors';
import { getLicenseTypes } from '../../../../../../store/licenseType/actions';
import { SearchSelectField } from '../../../../configs';

function LicenseTypeSelect({ onChange, ...rest }: SelectProps<SelectOption>) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const licenseTypeNature = useLicenseTypeNature();
  const licenseAbbreviation = useLicenseAbbreviation();

  const { data: licenseTypes, loading, isFetched } = useSelector(licenseTypesSelector(licenseTypeNature));

  const licenseTypeSelectOptions = useMemo(
    () => getSelectOptionsFromObjectArray(licenseTypes, 'licenseTypeCode', 'licenseTypeCode', null, t),
    [licenseTypes, t]
  );

  useEffect(() => {
    if (!licenseTypes.length && !isFetched) {
      dispatch(getLicenseTypes({ licenseTypeNature }));
    }
  }, [dispatch, licenseTypes.length, isFetched, licenseTypeNature]);

  return (
    <Select
      placeholder={t('Type of {{licenseAbbreviation}}', { licenseAbbreviation: t(licenseAbbreviation) })}
      loadingMessage={() => t('Loading...')}
      name={SearchSelectField.licenseType}
      options={licenseTypeSelectOptions}
      isLoading={loading}
      onChange={onChange}
      isClearable
      {...rest}
    />
  );
}

export default LicenseTypeSelect;
